import React from "react"
import styled from "styled-components/macro"
import {
  IncidentEscortState
} from "incident-code-core"

import { colors, fonts, strings } from "../../../../constants"
import { EscortCardStateLabel, PanicMode } from '../../../../scenes/AllIncidents/Cards/EscortCard/Label'

interface IStatusProps {
  status: IncidentEscortState,
  type?: string
  timerExpired?: boolean
  isPanic?: boolean
  isSafe?: boolean
  panicMode?: PanicMode
}

export const Status: React.FC<IStatusProps> = ({ status, type, timerExpired, isPanic, isSafe, panicMode }) => {
  let state = '';
  switch (status) {
    case IncidentEscortState.Active:
      state = strings.escortDetail.active;
      break;

    case IncidentEscortState.Panic:
      state = strings.escortDetail.panic;
      break;

    case IncidentEscortState.Background:
      state = strings.escortDetail.background;
      break;

    case IncidentEscortState.Unknown:
      state = strings.escortDetail.unknown;
      break;

    case IncidentEscortState.Closed:
      state = strings.escortDetail.closed;
      break;

    case IncidentEscortState.Safe:
      state = strings.escortDetail.safe;
      break;

    case IncidentEscortState.Expired:
      state = strings.escortDetail.expired;
      break;

    case IncidentEscortState.Canceled:
      state = strings.escortDetail.canceled;
      break;

    default:
      state = strings.escortDetail.pending;
      break;
  }
  
  console.log('%%%%%%%%%%%%%%%%state', state, 'type', type, 'timerExpired', timerExpired, 'isPanic', isPanic, 'isSafe', isSafe)

  return (
    <Container>
      <Title>
        <TitleText>
          {isPanic === true ? (
            <PanicLabel>PANIC</PanicLabel>
          ) : (status === IncidentEscortState.Safe && isPanic) ? (
            <SafeLabel>SAFE</SafeLabel>
          ) : timerExpired === true ? (
            <TimerExpiredLabel>TIMER EXPIRED</TimerExpiredLabel>
          ) : (
            <VirtualEscortLabel>Virtual Escort</VirtualEscortLabel>
          )}
        </TitleText>
      </Title>
    </Container>
  )
}


const Container = styled.div`
  flex-grow: 1;
  align-items: flex-start;
`
const Title = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`
const TitleText = styled.h2`
  font-family: ${fonts.defaultFont};
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: -0.2px;
  text-align: center;
  color: ${colors.ghostWhite};
`

const PanicLabel = styled.span`
  display: inline-block;
  background-color: rgba(255, 0, 0);
  color: white;
  font-weight: bold;
  text-align: center;
  margin-left: 14px;
  margin-right: 14px;
  padding: 5px;
  width: 375px;
`

const SafeLabel = styled.span`
  display: inline-block;
  background-color: rgba(0, 186, 50);
  color: white;
  font-family: serif;
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  padding: 8px 16px;
  margin-left: 8px;
  text-align: center;
  width: 375px;
  text-shadow: 0 0 6px rgba(255, 255, 255, 0.8), 0 0 10px rgba(255, 255, 255, 0.5);
`

const TimerExpiredLabel = styled.span`
  display: inline-block;
  background-color: rgba(0, 93, 130);
  color: white;
  font-weight: bold;
  text-align: center;
  margin-left: 14px;
  margin-right: 14px;
  padding: 5px;
  width: 375px;
`

const VirtualEscortLabel = styled.span`
  display: inline-block;
  background-color: rgba(0, 93, 130);
  color: white;
  font-weight: bold;
  text-align: center;
  margin-left: 14px;
  margin-right: 14px;
  padding: 5px;
  width: 375px;
`